import type { IconProps } from "@/types/icon";

const List = ({ color = "black", className }: IconProps) => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_3840_3439)">
      <path
        d="M11.3988 6.99988L5.3538 6.99988M11.3988 3.97738L5.3538 3.97738M11.3988 10.0224L5.3538 10.0224M3.3388 6.99988C3.3388 7.2781 3.11326 7.50363 2.83505 7.50363C2.55684 7.50363 2.3313 7.2781 2.3313 6.99988C2.3313 6.72167 2.55684 6.49613 2.83505 6.49613C3.11326 6.49613 3.3388 6.72167 3.3388 6.99988ZM3.3388 3.97738C3.3388 4.2556 3.11326 4.48113 2.83505 4.48113C2.55684 4.48113 2.3313 4.2556 2.3313 3.97738C2.3313 3.69917 2.55684 3.47363 2.83505 3.47363C3.11326 3.47363 3.3388 3.69917 3.3388 3.97738ZM3.3388 10.0224C3.3388 10.3006 3.11326 10.5261 2.83505 10.5261C2.55684 10.5261 2.3313 10.3006 2.3313 10.0224C2.3313 9.74417 2.55684 9.51863 2.83505 9.51863C3.11326 9.51863 3.3388 9.74417 3.3388 10.0224Z"
        stroke={color}
        strokeWidth="1.209"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3840_3439">
        <rect
          width="12.09"
          height="12.09"
          fill="white"
          transform="translate(0.820068 0.955078)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default List;
